import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexto/AuthContext';

function Logout() {
    const navigate = useNavigate();
    const { logout } = useContext(AuthContext);

    useEffect(() => {
        const handleLogout = async () => {
            await logout();
            // Redirigir al login después de logout
            navigate('/login');
            setTimeout(() => {
                window.location.href = '/login';
            }, 100);
        };

        handleLogout();
    }, [navigate, logout]);

    return (
        <>
            <title>Logout</title>
            <div className="App bg-dark text-white d-flex justify-content-center align-items-center" style={{height: '90vh'}}>
                <p>Cerrando sesión...</p>
            </div>
        </>
    );
}

export default Logout;